import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ITeacherStaffInterview } from '../models/teacherStaffInterview';
import { IWitnessInterview } from '../models/witnessInterview';

@Injectable({
  providedIn: 'root'
})
export class WitnessInterviewService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getWitnessInterviewByCaseId(caseId: string): Observable<IWitnessInterview> {
        const url = environment.apiBaseUrl + endpoints.getWitnessInterviewByCaseId.replace(':caseId', caseId);
        return this.http.get<IWitnessInterview>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateWitnessInterviewByCaseId(data: IWitnessInterview): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateWitnessInterview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}